// Port of api/fuel/app/classes/filter/search/games/rules/query/date_played.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'date_played',
	field: function() { return 'p.play_date' }
})
